import { requests } from '@/libs/axios/axios'
import { ChatEndpoints } from '../chat-endpoints'

export const sendMessage = async (data: { message: string; path_id: string; chat_id: string }) => {
  return requests.post(ChatEndpoints.SEND_MESSAGE, data, {
    timeout: 30000
  })
}
